module.exports = __webpack_public_path__ + "img/no-image-placeholder-carausol.4197f5e5.png";